/**
 * Nice Shot — PDP gallery zoom.
 *
 * Desktop (fine pointer): clicking a gallery photo zooms IN PLACE, 2.2x, following the cursor.
 * No overlay, no layout shift. The 2048px source is preloaded on hover so the first click is
 * instant; until it lands we scale the image already on screen, so a zoom never waits on a
 * network round trip.
 *
 * Touch / coarse pointer: keeps the fullscreen overlay, where native pinch-zoom works. In-place
 * zoom is a cursor interaction and has no good touch equivalent.
 *
 * Close: click again, move off the image, or press Escape.
 */
(function () {
  var ZOOM = 2.2;
  var fine = window.matchMedia && window.matchMedia('(pointer: fine)').matches;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function hiRes(src) {
    try {
      var u = new URL(src, location.href);
      u.searchParams.set('width', '2048');
      return u.href;
    } catch (e) {
      return src;
    }
  }

  /* ---------------------------------------------------------------- in-place (desktop) */

  var preloaded = {}; // src -> true once the 2048px version is in the browser cache

  function preload(img) {
    var src = img.currentSrc || img.src;
    if (!src || preloaded[src]) return;
    preloaded[src] = true;
    var pre = new Image();
    pre.decoding = 'async';
    pre.src = hiRes(src);
    pre.onload = function () {
      img.setAttribute('data-ns-hires', pre.src);
    };
  }

  function originFrom(img, e) {
    var r = img.getBoundingClientRect();
    var ox = ((e.clientX - r.left) / r.width) * 100;
    var oy = ((e.clientY - r.top) / r.height) * 100;
    img.style.transformOrigin = ox + '% ' + oy + '%';
  }

  function unzoom(img) {
    img.classList.remove('is-zoomed');
    img.style.transform = '';
    img.style.transformOrigin = '';
    var stage = img.closest('[data-ns-gallery-stage]');
    if (stage) stage.classList.remove('is-zooming');
  }

  function zoom(img, e) {
    // Swap to the high-res source only once it is decoded; otherwise scale what is on screen.
    var hi = img.getAttribute('data-ns-hires');
    if (hi && img.src !== hi) img.src = hi;
    originFrom(img, e);
    img.style.transform = 'scale(' + ZOOM + ')';
    img.classList.add('is-zoomed');
    var stage = img.closest('[data-ns-gallery-stage]');
    if (stage) stage.classList.add('is-zooming');
  }

  function bindInPlace() {
    document.addEventListener(
      'pointerenter',
      function (e) {
        var img = e.target.closest && e.target.closest('.ns-main__gallery-img');
        if (img) preload(img);
      },
      true
    );

    document.addEventListener('click', function (e) {
      var img = e.target.closest && e.target.closest('.ns-main__gallery-img');
      if (!img) return;
      e.preventDefault();
      if (img.classList.contains('is-zoomed')) unzoom(img);
      else zoom(img, e);
    });

    document.addEventListener('mousemove', function (e) {
      var img = e.target.closest && e.target.closest('.ns-main__gallery-img.is-zoomed');
      if (img) originFrom(img, e);
    });

    document.addEventListener(
      'pointerleave',
      function (e) {
        var img = e.target.closest && e.target.closest('.ns-main__gallery-img.is-zoomed');
        if (img) unzoom(img);
      },
      true
    );

    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      var z = document.querySelector('.ns-main__gallery-img.is-zoomed');
      if (z) unzoom(z);
    });
  }

  /* ---------------------------------------------------------------- overlay (touch) */

  var box = null;

  function build() {
    var overlay = document.createElement('div');
    overlay.className = 'ns-zoom';
    overlay.setAttribute('role', 'dialog');
    overlay.setAttribute('aria-modal', 'true');
    overlay.setAttribute('aria-label', 'Zoomed product image');
    overlay.hidden = true;
    overlay.innerHTML =
      '<button class="ns-zoom__close" type="button" aria-label="Close">&times;</button>' +
      '<img class="ns-zoom__img" alt="">';
    document.body.appendChild(overlay);
    var img = overlay.querySelector('.ns-zoom__img');

    function close() {
      overlay.hidden = true;
      document.body.style.overflow = '';
    }
    overlay.addEventListener('click', function (e) {
      if (e.target === overlay || e.target.classList.contains('ns-zoom__close')) close();
    });
    document.addEventListener('keydown', function (e) {
      if (!overlay.hidden && e.key === 'Escape') close();
    });
    return { overlay: overlay, img: img, close: close };
  }

  function openOverlay(src) {
    if (!box) box = build();
    box.img.src = hiRes(src);
    box.overlay.hidden = false;
    document.body.style.overflow = 'hidden';
  }

  function bindOverlay() {
    document.addEventListener('click', function (e) {
      var img = e.target.closest && e.target.closest('.ns-main__gallery-img');
      if (!img) return;
      e.preventDefault();
      openOverlay(img.currentSrc || img.src);
    });
  }

  if (fine && !reduce) bindInPlace();
  else bindOverlay();
})();
